import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-full text-xs font-semibold transition-all duration-200 select-none border",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "bg-slate-100 text-slate-700 border-slate-200 hover:bg-slate-200",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "bg-slate-50 text-slate-700 border-slate-300 hover:bg-slate-100",
        success: "bg-green-100 text-green-700 border-green-200 hover:bg-green-200",
        warning: "bg-yellow-100 text-yellow-700 border-yellow-200 hover:bg-yellow-200",
        danger: "bg-red-100 text-red-700 border-red-200 hover:bg-red-200",
        info: "bg-sky-100 text-sky-700 border-sky-200 hover:bg-sky-200",
        orange: "bg-orange-100 text-orange-700 border-orange-200 hover:bg-orange-200",
        primary: "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100",
      },
      size: {
        sm: "px-2 py-0.5 text-xs",
        md: "px-2.5 py-1 text-xs",
        lg: "px-3 py-1 text-sm",
      },
    },
    defaultVariants: {
      variant: "secondary",
      size: "md",
    },
  }
)

export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"]

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, size }), className)} {...props} />
}

export { Badge, badgeVariants }
